import { prepareInterceptor } from './interceptor.js';
import { setUISelectionClean } from './selection.js';
import { setUIValueClean } from './value.js';

function prepareRangeTextInterceptor(element) {
    prepareInterceptor(element, 'setRangeText', function interceptorImpl(...realArgs) {
        return {
            realArgs,
            then: ()=>{
                setUIValueClean(element);
                setUISelectionClean(element);
            }
        };
    });
}

export { prepareRangeTextInterceptor };
